
export const dashboard = {
    thresholdKeys: {
        sent: "SENT_VOLUME_BY_EVENT_TYPE",
        open: "OPEN_RATE_BY_EVENT_TYPE",
        click: "CLICK_RATE_BY_EVENT_TYPE",
        complaint: "COMPLAINT_RATE_BY_EVENT_TYPE",
    },
    thresholdTriggerTypes: {
        SUPERIOR: true,
        INFERIOR: false,
    },
    pagination: {
        defaultPageSize: 10,
        pageSizeOptions: [5, 10, 25],
        showFirstLastButtons: true,
        maxVisiblePages: 5
    },
    emailProviderThreshold: 1,
};
